import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	ProfileContactViewResource,
	ProfileSettingsRequest,
	ProfileSettingsResource,
} from "../shared/types/profileSettings";

const baseKey = ["profile-settings"];
const getDefaultContactViewKey = [...baseKey, "default-contact-view"];

export const profileSettingsService = {
	showKey: baseKey,
	show: () => axios.get<LaravelResponse<ProfileSettingsResource>>(keyToUrl(baseKey)),
	update: (request: ProfileSettingsRequest) => axios.put(keyToUrl(baseKey), request),
	getDefaultContactViewKey,
	getDefaultContactView: () =>
		axios.get<LaravelResponse<ProfileContactViewResource>>(keyToUrl(getDefaultContactViewKey)),
};
